import React, { useState } from "react";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../redux/action/index";
import { ReactComponent as HeadImg } from "@/assets/icons/headImg.svg";
import { ReactComponent as Jingge } from "@/assets/icons/jingge.svg";
import InitState from "./component/InitState";
import EmailLogin from "./component/EmailLogin";
import ForgetPassword from "./component/ForgetPassword";
import ResetPassword from "./component/ResetPassword";
import Security from "./component/Security";
import SignUpEmail from "./component/SignUpEmail";
import { SwitchTransition, CSSTransition } from "react-transition-group";
// import sentGAEvent from "@/ga";
import { useEffect } from "react";
import './index.less'
const LoginComponent = (props) => {
  const [step, setStep] = useState(1);
  const reducerData = useSelector((state) => state.common);
  const dispatch = useDispatch();
  const { signUpModal } = reducerData;

  const handleCancel = () => {

    dispatch(
      actions.onSignUpModal({
        visible: false,
      })
    );

  };


  useEffect(() => {
    console.log(signUpModal.counts)
    if (signUpModal?.step === 6) {
      setStep(6);
    }
    if (signUpModal?.step === 2) {
      setStep(2);
    }

  }, [signUpModal])


  return (
    <Modal
      destroyOnClose
      className="signUpModal"
      centered
      maskClosable={false}
      visible={signUpModal.visible}
      title={null}
      footer={null}
      afterClose={() => setStep(1)}
      onCancel={() => handleCancel()}
    >
      <HeadImg className="headImg" />
      <Jingge className="jingge" />
      <SwitchTransition mode="out-in">
        <CSSTransition
          key={step}
          // timeout={500}
          addEndListener={(node, done) =>
            node.addEventListener("transitionend", done, false)
          }
          unmountOnExit={true}
          classNames="fade"
        >
          {step === 1 ? (
            <div key="initState">
              <InitState changeStep={setStep} handleCancel={handleCancel} />
            </div>
          ) : step === 2 ? (
            <div key="emailLogin">
              <EmailLogin changeStep={setStep} handleCancel={handleCancel} />
            </div>
          ) : step === 3 ? (
            <div key="signUpEmail">
              <SignUpEmail changeStep={setStep} handleCancel={handleCancel} />
            </div>
          ) : step === 4 ? (
            <div key="forgetPassword" handleCancel={handleCancel}>
              <ForgetPassword changeStep={setStep} handleCancel={handleCancel} />
            </div>
          ) : step === 5 ? (
            <div key="resetPassword">
              <ResetPassword changeStep={setStep} handleCancel={handleCancel} />
            </div>
          ) : step === 6 ? (
            <div key="security">
              <Security changeStep={setStep} handleCancel={handleCancel} />
            </div>
          ) : (
            ""
          )}
        </CSSTransition>
      </SwitchTransition>
    </Modal>
  );
};

export default LoginComponent;
